import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import {
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import FrequentlyAskedPage from '../components/FrequentlyAskedPage/FrequentlyAskedPage'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      displayProfileModal,
      setProfileModalPage,
      push,
    },
    dispatch,
  )

const ConnectedFrequentlyAskedPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FrequentlyAskedPage)

export default ConnectedFrequentlyAskedPage
